// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loading-container {
  display: flex;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #343a40;
  z-index: 9999;
  opacity: 0.4;
  padding: 20%;
 }

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvYWRlci5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQTtFQUNFLGFBQWE7RUFDYix1QkFBdUI7RUFDdkIsZUFBZTtFQUNmLFdBQVc7RUFDWCxZQUFZO0VBQ1oseUJBQXlCO0VBQ3pCLGFBQWE7RUFDYixZQUFZO0VBQ1osWUFBWTtDQUNiIiwiZmlsZSI6ImxvYWRlci5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG4ubG9hZGluZy1jb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgcG9zaXRpb246IGZpeGVkO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjMzQzYTQwO1xuICB6LWluZGV4OiA5OTk5O1xuICBvcGFjaXR5OiAwLjQ7XG4gIHBhZGRpbmc6IDIwJTtcbiB9XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/loader/loader.component.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,YAAY;CACb;;AAED,goBAAgoB","sourcesContent":["\n.loading-container {\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: #343a40;\n  z-index: 9999;\n  opacity: 0.4;\n  padding: 20%;\n }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
